import React from 'react';

import {
  Button,
  FlexItem,
  SplitLayout, StackLayout,
} from '@salt-ds/core';
import {TriangleLeftIcon} from '@salt-ds/icons';
import {useNavigate} from 'react-router';

export default function PageNavigationCustom(props) {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/");
  }

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleButtonClick = () => {
    props.onSubmit()
  }

  const startItem = <StackLayout direction={{
    sm: "row"
  }} gap={1}>
    <FlexItem>
      {!props.isCancelNotAllowed &&
        <Button sentiment="accented" appearance="transparent" onClick={handleBackToLogin} style={{}} disabled={props.isLoading}>
          CANCEL
        </Button>}
    </FlexItem>
  </StackLayout>;

  const endItem = <StackLayout direction={{
    sm: "row"
  }} gap={2}>
    {props.backButton &&
      <FlexItem>
        <Button sentiment="accented" appearance="transparent" onClick={handleBackClick} disabled={props.isLoading}>
          <TriangleLeftIcon aria-hidden />
          BACK
        </Button>
      </FlexItem>}
    <FlexItem>
      <Button sentiment="accented" appearance="solid" type="submit" onClick={handleButtonClick} style={{}} disabled={props.isLoading}>
        {props.nextButtonText !== undefined && props.nextButtonText != null && props.nextButtonText.length !== 0 ? props.nextButtonText : "NEXT"}
      </Button>
    </FlexItem>
  </StackLayout>;

  return (
    <SplitLayout startItem={startItem} endItem={endItem} gap={1} direction={{
      sm: "row"
    }} style={{
      width: "100%",
    }} />
  );
}